import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const Wrapper = styled.div`
  background-color: ${themeGet('colors.white')};
`;

export const StyledContainer = styled(Container)`
  padding: 50px 0 60px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    flex-direction: row;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 70px 0px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    padding: 70px 45px 90px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.max')}) {
    padding: 70px 90px 90px;
  }
`;

export const Content = styled.div`
  border-bottom: 1px solid #95a1ad;
  padding-bottom: 30px;
  // padding-top: 40px;

  h2,
  h3,
  h4 {
    margin-bottom: 30px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    border-bottom: none;
    padding-top: 0;
    padding-bottom: 50px;
    padding-right: 50px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-bottom: 0;
    padding-right: 75px;
  }
`;

export const Sidebar = styled.div`
  padding-top: 40px;
  max-width: 414px;

  .departments-container {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: -0.2px;
    line-height: 32px;
  }

  a {
    text-decoration: none;
    border-bottom: none;

    font-size: 18px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 32px;

    color: ${themeGet('colors.orange')};

    &:focus,
    &:hover {
      text-decoration: none;
      border-bottom: none;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xs')}) {
    .departments-container {
      flex-direction: row;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    .departments-container {
      flex-direction: column;
    }
    max-width: 100%;

    width: 280px;
    min-width: 280px;
    border-left: 1px solid #95a1ad;
    padding: 0 0 0 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 350px;
    min-width: 350px;

    .departments-container {
      flex-direction: row;
    }
  }
`;

export const Departments = styled.ul`
  display: block;

  && {
    margin: 0;
  }

  li {
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xs')}) {
    && {
      margin-left: auto;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: block;

    && {
      margin: 0px;
    }

    li {
      margin: 0px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding-left: 20px;
  }
`;

export const SocialLinks = styled.div`
  bottom: 35px;
  display: block;
  margin-left: 0px;
  justify-content: center;

  a {
    &:focus,
    &:hover {
      opacity: 0.8;
    }
  }

  img {
    margin: 0 15px;
    height: 100%;
    width: 100%;
    max-height: 24px;
    max-width: 24px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    .social-icons-container {
      margin-left: 30px;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    bottom: 95px;
    .social-icons-container {
      text-align: left;
    }
  }
`;
